<template>
  <div>
    <el-dialog title="反馈"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :append-to-body="true"
               width="554rem"
               :before-close="handleClose">
      <div class="block">
        <span :class="form.category == 0?'isActive':''"
              @click="checkType(0)">
          题目反馈
        </span>
        <span :class="form.category == 1?'isActive':''"
        v-if="form.correct_type!=2"
              @click="checkType(1)">
          批改反馈 
        </span>

        <span :class="form.category == 2?'isActive':''"
        
              @click="checkType(2)">
          解法反馈 
        </span>
      </div>
      <el-form :model="form"
               label-width="70rem">
        <el-form-item label="反馈">
          <el-input placeholder="请输入反馈内容"
                    type="textarea"
                    :rows="5"
                    style="width:90%"
                    v-model="form.comment" />
        </el-form-item>
     
        <el-row>
          <el-form-item label-width="0rem"
                        style="margin-left:70rem; "  >
        <span class="desction">
   <i class="el-icon-warning" style="color: #ff6147; font-size: 16px;"></i>
  {{
    form.category == 0 ? '题目有错误，反馈内容才有效' :
    form.category == 1 ? '批改有错误，反馈内容才有效' :
    form.category == 2 ? '反馈内容为对解法的意见和建议，才有效' :
    '请选择反馈类型'
  }}
</span>
          </el-form-item>
        </el-row>
             <el-form-item label="图片" v-show="form.category==2">


           <div class="img_list"> 
             <div class="img_wrap"
                       v-for="(item,index) in images"
                       :key="index">
                    <img class="del"
                         @click="del(index)"
                         src="@/assets/icons/删除.png"
                         alt="">
                    <el-image class="answer"
                              :src="$addHeader(item)"
                              :preview-src-list="$addForHeader(item)"
                              alt=""></el-image>

                  </div>
                  <div class="add_img"
                       v-if="images.length  != 1"
                       @click="uploadImage">
                    <div>
                      <img src="@/assets/add_img.png"
                           alt="">
                    </div>
                    点击上传
                  </div>
                  </div>
        </el-form-item>
         <el-row v-show="form.category=='2'">
          <el-form-item label-width="0rem"
                        style="margin-left:70rem"  >
        <span class="desction">
   <i class="el-icon-warning" style="color: #ff6147; font-size: 16px;"></i><span>反馈的解法可拍照上传</span>
</span>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="btn_warp">
        <div @click="handleClose">
          取消
        </div>
        <div @click="save">
          确定
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadFile, uploadImageAuto } from '@/api/upload.js'

import { errorCorrect } from '@/api/error.js'
export default {
  data () {
    return {
      dialogVisible: false,
      form: {},
      images: [],
    }
  },
  methods: {
      async uploadImage (answer_id) {
      
        const { data } = await uploadImageAuto()
        this.images = Object.values(this.images);
        this.images.push(data.info.name)
           
        },
    del (answer_id, index) {
      
        this.images.splice(index, 1)
       
    },
    handleClose () {
      this.dialogVisible = false
      this.images = []
    },
    async save () {
      if (this.form.comment == '') {
        this.$message.warning('请输入反馈内容')
        return
      }
      if(this.form.category == 2 && this.images.length > 0){
       this.form.feedback_image= this.images.join(',')
      }
      
      let form = JSON.parse(JSON.stringify(this.form))
      if (form.category == 0) {
        delete form.user_paper_detail_id
      }
        
      await errorCorrect(form)
      this.$message.success('反馈成功')
      this.handleClose()
    },
    checkType (num) {
      this.form.category = num
    }
  }
}
</script>

<style lang="scss" scoped>
.btn_warp {
  height: 64rem;
  border-top: 1rem solid #e5e5e5;
  display: flex;
  width: 554rem;
  margin-left: -32rem;
  margin-top: 16rem;
  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &:nth-child(1) {
      font-size: 24rem;
      font-weight: 400;
      color: #333;
      border-right: 1rem solid #e5e5e5;
    }
    &:nth-child(2) {
      font-size: 24rem;
      font-weight: 400;
      color: #2196f3;
    }
  }
}
::v-deep .el-dialog__body {
  padding: 12rem 32rem 0rem 32rem;
}

::v-deep .el-dialog__header {
  font-size: 18rem;
  font-weight: 500;
  color: #333333;
  text-align: center;
}
::v-deep .el-dialog {
  border-radius: 10rem;
  margin-top: 23vh !important;
}

::v-deep .el-form-item__label {
  color: #333333;
  font-size: 24rem;
  font-weight: 400;
  margin-top:10% ;
}
  .add_img {
    width: 120rem;
    height: 120rem;
    background: #f6f6f6;
    border-radius: 10rem;
    font-size: 20rem;
    font-weight: 500;
    color:  #666666;
    text-align: center;
    cursor: pointer;
    img {
      width: 40rem;
      height: 34rem;
      margin-top: 26rem;
      margin-bottom: 6rem;
    }
  }
   .img_list {
    // margin-top: 30rem;
    display: flex;
.img_wrap {
      position: relative;
      margin-right: 24rem;
      display: flex;
      width: 120rem;
      height: 120rem;
      .del {
        position: absolute;
        right: -15rem;
        top: -15rem;
        width: 30rem;
        height: 30rem;
        cursor: pointer;
      }
      .answer {
        border-radius: 10rem;
        width: 120rem;
        height: 120rem;
      }
         
      }
    }
.block {
  display: flex;
  margin-bottom: 20rem;
  span {
    padding: 7rem 18rem;
    font-size: 20rem;
    // font-weight: bold;
    color: #666666;
    border-radius: 5rem;
    background: #f6f6f6;
    &:nth-child(2) {
      margin-left: 20rem;
    }
     &:nth-child(3) {
      margin-left: 20rem;
    }
  }
}
.isActive {
  background: #007af0 !important;
  color: white !important;
}

::v-deep .el-dialog__close {
  display: none;
}
::v-deep .el-dialog__title {
color: var(--light-333333, #333);
text-align: center;
 
font-size: 24rem;
font-style: normal;
font-weight: 600;
line-height: 36px; /* 150% */;
}
 .el-form-item{
  margin-bottom: 10rem !important;
}
::v-deep .el-textarea__inner {
  font-size: 24rem;
  
}
::v-deep .el-dialog {
  border-radius: 32rem;
 
}
.desction {
  font-size: 16rem;
  // font-weight: bold;
  color: #ff6147;
}
</style>